<template>
  <!-- 规则设置——左侧目录 -->
  <div class="ruleLeft">
    <!-- 操作按钮 -->
    <div class="leftButtons">
      <el-button type="primary" size="small" @click="addRuleOpen">新建配置</el-button>
      <!-- <el-button size="small" @click="openEditNameDialog">编辑</el-button>
      <el-button type="danger" size="small" @click="handleDel">删除</el-button> -->
    </div>
    <!-- 目录树 -->
    <div class="treeArea">
      <el-tree
        ref="tree"
        node-key="ruleId"
        :props="defaultProps"
        :accordion="false"
        highlight-current
        :data="treeData"
        :default-expanded-keys="unfoldIdArr"
        @node-expand="treeExpand"
        @node-collapse="treeCollapse"
        @node-click="clickNodeTree"
      >
        <div slot-scope="{ node, data }" style="width: 100%">
          <!-- 正常状态 -->
          <div class="treeItem">
            <!-- <img :src="ruleSetLeftTreeIcon(node.data)" alt="图标" class="itemImg" /> -->
            <div class="itemName" :title="data.ruleName">{{ data.ruleName }}</div>
            <el-dropdown v-if="data.ruleId" trigger="click" placement="bottom-start">
              <i class="el-icon-more"></i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="openEditNameDialog(data)">编辑</el-dropdown-item>
                <el-dropdown-item v-if="data.orderNum !== 0" @click.native="handleDel(data)">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </el-tree>
    </div>

    <!-- 新建规则弹框 -->
    <el-dialog
      v-dialogDrag
      :visible.sync="addRuleSetOpen"
      title="新增配置"
      width="425px"
      top="25vh"
      class="dialogRevitAddSet"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="resetAddDialog"
    >
      <!-- 表单 -->
      <div class="desc">请从已有配置中复制新增</div>
      <el-form ref="addRuleForm" :model="addRuleForm" label-position="top" size="small" :rules="addRules">
        <el-form-item label="所复制配置名称" prop="sourceRuleId">
          <el-select v-model="addRuleForm.sourceRuleId" placeholder="请选择" style="width: 100%" filterable clearable size="small">
            <el-option v-for="item in treeData" :key="item.ruleId" :label="item.ruleName" :value="item.ruleId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="新增配置名称" prop="ruleName">
          <el-input ref="name" v-model.trim="addRuleForm.ruleName" placeholder="请输入规则设置名称" maxlength="50" show-word-limit clearable size="small"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="addRuleSetOpen = false">取 消</el-button>
        <el-button type="primary" size="small" @click="addRuleSet">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑名称对话框 -->
    <el-dialog title="编辑名称" :visible.sync="editNameDialogVisible" width="30%" :before-close="handleCloseEditNameDialog">
      <el-input v-model="currentEditName" placeholder="请输入新的名称" clearable size="small"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="editNameDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="handleEditName">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { ruleSetLeftTreeIcon } from "@/CommonDP/utils/docPublic";
import revitSetService from "@/CommonDP/service/revitSet-service";

export default {
  components: {},
  data() {
    return {
      defaultProps: {
        children: "ruleSettingsVos",
        label: "name"
      },
      unfoldIdArr: [], // 默认展开文件id
      ruleLeftData: [], // 目录树数据
      currentData: {}, // 当前的文件夹
      currentRuleId: "", // 当前规则id
      currentEditType: "", // 当前编辑状态的类型
      currentEditId: "", // 当前编辑状态的id
      currentEditName: "", // 当前编辑状态的name

      addRuleSetOpen: false, // 新增规则设置弹框
      addRuleForm: {
        ruleName: "",
        sourceRuleId: ""
      }, // 新增规则表单
      addRules: {
        ruleName: [{ required: true, message: "请输入新增配置名称", trigger: "blur" }],
        sourceRuleId: [{ required: true, message: "请选择复制配置名称", trigger: "change" }]
      },
      editNameDialogVisible: false // 编辑名称对话框是否可见
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo
    }),

    // 目录树数据
    treeData() {
      let list = this.ruleLeftData || [];
      list = list.filter((item) => item.type !== "personal");
      return list;
    }
  },
  async mounted() {
    await this.getRuleLeftData();
  },
  methods: {
    // 打开编辑名称对话框
    openEditNameDialog(data) {
      // if (!this.currentData?.ruleId) return this.$warn("请选择目录");
      this.currentEditName = data.ruleName;
      this.editNameDialogVisible = true;
    },
    // 关闭编辑名称对话框
    handleCloseEditNameDialog() {
      this.editNameDialogVisible = false;
    },
    // 处理编辑名称
    async handleEditName() {
      // 这里添加处理编辑名称的逻辑
      this.editNameDialogVisible = false;
      await revitSetService.editRuleSetLeft({
        ...this.currentData,
        ruleName: this.currentEditName
      });
      this.$message.success("重命名成功");
      this.getRuleLeftData();
    },
    // 获取规则左侧数据
    async getRuleLeftData() {
      const res = await revitSetService.getRuleLeftData(this.enterpriseId);
      this.ruleLeftData = res.data || [];
      const target = this.ruleLeftData.find((item) => item.ruleId === this.currentData.ruleId);
      console.log(target);
      if (target) {
        this.currentData = target;
      } else {
        this.currentData = res.data[0] || {};
      }
      this.$emit("setCurrentRule", this.currentData);

      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(this.currentData.ruleId);
      });
    },

    // 树前面的图标
    ruleSetLeftTreeIcon(data) {
      return ruleSetLeftTreeIcon(data);
    },
    // 单个树展开
    treeExpand(data, node) {
      this.unfoldIdArr.push(data.specId);
    },
    // 单个树收起
    treeCollapse(data, node) {
      for (let i = 0; i < this.unfoldIdArr.length; i++) {
        if (this.unfoldIdArr[i] === data.specId) {
          this.unfoldIdArr.splice(i, 1);
        }
      }
    },
    // 点击树节点
    clickNodeTree(data, node, resolve) {
      this.currentData = data;
      this.$emit("setCurrentRule", data);
    },

    // 打开新增规则弹框
    addRuleOpen() {
      this.addRuleSetOpen = true;
      this.$nextTick(() => {
        this.$refs.name.focus();
      });
    },
    handleDel(data) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        if (data.orderNum === 0) {
          return this.$warn("默认配置不可删除！");
        }
        await revitSetService.deleteRuleSetLeft(data.ruleId);
        this.$message.success("删除成功");
        this.getRuleLeftData();
      });
    },
    // 重置新增弹框
    resetAddDialog() {
      this.addRuleForm.sourceRuleId = "";
      this.addRuleForm.ruleName = "";
      this.$refs.addRuleForm.resetFields();
    },
    // 新增规则弹框提交
    addRuleSet() {
      this.$refs.addRuleForm.validate(async (valid) => {
        if (valid) {
          const params = {
            enterpriseId: this.enterpriseId,
            ruleName: this.addRuleForm.ruleName,
            sourceRuleId: this.addRuleForm.sourceRuleId
          };
          await revitSetService.addRuleSetLeft(params);
          await this.getRuleLeftData();
          this.$message.success("添加规则设置成功");
          this.addRuleSetOpen = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.ruleLeft {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .leftButtons {
    width: 100%;
    padding: var(--middle-space) var(--big-space);
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e5e8f1;
  }

  .treeArea {
    width: 100%;
    height: 1px;
    flex: 1 0 1px;
    height: calc(100% - 55px);
    padding: var(--middle-space) 0;
    overflow-y: auto;

    .treeItem {
      width: 100%;
      display: flex;
      align-items: center;
      overflow: hidden;
      padding-right: 25px;

      .itemImg {
        margin-right: 6px;
        -webkit-user-drag: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -khtml-user-select: none;
        user-select: none;
      }

      .itemName {
        width: 1px;
        flex-grow: 1;
        margin-right: 10px;
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
.dialogRevitAddSet {
  .desc {
    color: #497aef;
    margin-bottom: 10px;
    font-size: 14px;
  }
}
</style>
